export default {
  ACCOUNT_FUNDING_SOURCE_HEADER: "Where do your investment funds come from?",
  RADIO_ITEMS: [
    {
      label: "Employment Income",
      value: "Employment Income",
    },
    {
      label: "Investments",
      value: "Investments",
    },
    {
      label: "Inheritance",
      value: "Inheritance",
    },
    {
      label: "Business Income",
      value: "Business Income",
    },
    {
      label: "Savings",
      value: "Savings",
    },
    {
      label: "Family",
      value: "Family",
    },
  ],
  ACCOUNT_FUNDING_SOURCE_BUTTON_HEADING: "Continue",
  SUBMIT_ERROR: "Enter a Valid Amount",
};
